import { Link } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { apiFetch } from '@/lib/api'

// ─── Icônes (line-art, pas d'emoji) ────────────────────────────────────────────

function IconBuilding({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
      <path d="M9 8h1M9 12h6M9 16h6" />
    </svg>
  )
}

function IconGraduationCap({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 9.5 12 5l10 4.5-10 4.5-10-4.5Z" />
      <path d="M6 11.5V16c0 1.66 2.69 3 6 3s6-1.34 6-3v-4.5" />
      <path d="M22 9.5v5" />
    </svg>
  )
}

function IconShield({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3 5 6v6c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V6l-7-3Z" />
      <path d="m9.5 12 1.75 1.75L15 10" />
    </svg>
  )
}

function IconUser({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
    </svg>
  )
}

function IconFilePlus({ className }: { className?: string }) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
      <path d="M9 8h1M9 16h6" />
      <path d="M12 10.5v4M10 12.5h4" />
    </svg>
  )
}

function IconBell({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  )
}

function IconCheckCircle({ className }: { className?: string }) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="m8.5 12.5 2.5 2.5 5-5" />
    </svg>
  )
}

function IconCheck({ className }: { className?: string }) {
  return (
    <svg className={className} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  )
}

function IconMapPin({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 21s-7-5.33-7-11a7 7 0 0 1 14 0c0 5.67-7 11-7 11Z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  )
}

function IconCreditCard({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 9h18M7 15h4" />
    </svg>
  )
}

function IconStar({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <path d="m12 3 2.6 5.6 6.1.6-4.6 4.1 1.3 6-5.4-3.2-5.4 3.2 1.3-6-4.6-4.1 6.1-.6L12 3Z" />
    </svg>
  )
}

function IconBarChart({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 20V10M12 20V4M20 20v-7" />
    </svg>
  )
}

function IconSmartphone({ className }: { className?: string }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
      <path d="M11 18.5h2" />
    </svg>
  )
}

function IconArrowRight({ className }: { className?: string }) {
  return (
    <svg className={className} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  )
}

// ─── Navbar ──────────────────────────────────────────────────────────────────

const VOUS_ETES = [
  {
    icon: IconBuilding,
    label: 'Une entreprise',
    description: 'Publiez des missions, trouvez des intervenants qualifiés.',
    href: '/inscription/entreprise',
    color: 'text-accent',
    bg: 'bg-accent/10',
  },
  {
    icon: IconGraduationCap,
    label: 'Un centre de formation',
    description: 'Gérez vos sessions, recrutez des formateurs certifiés.',
    href: '/inscription/entreprise',
    color: 'text-success',
    bg: 'bg-success/10',
  },
  {
    icon: IconShield,
    label: 'Une entreprise CNPAS',
    description: 'Référencez-vous et recevez des demandes ADS/SSIAP.',
    href: '/inscription/entreprise',
    color: 'text-blue-300',
    bg: 'bg-blue-500/10',
  },
  {
    icon: IconUser,
    label: 'Un prestataire / intervenant',
    description: 'Recevez des missions près de chez vous, payées à la fin.',
    href: '/inscription/prestataire',
    color: 'text-warning',
    bg: 'bg-warning/10',
  },
] as const

function VousEtesDropdown() {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function onDown(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onDown)
    return () => document.removeEventListener('mousedown', onDown)
  }, [])

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 text-sm font-medium transition-colors ${open ? 'text-text-primary' : 'text-text-secondary hover:text-text-primary'}`}
      >
        Vous êtes…
        <svg
          className={`w-3.5 h-3.5 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div
          className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-80 rounded-2xl overflow-hidden border border-white/[0.10] z-50"
          style={{ background: 'rgba(10,10,20,0.97)', backdropFilter: 'blur(24px)' }}
        >
          <p className="text-text-muted text-[10px] font-semibold uppercase tracking-widest px-4 pt-4 pb-2">
            Je suis…
          </p>
          <div className="pb-3">
            {VOUS_ETES.map((item) => (
              <Link
                key={item.label}
                to={item.href}
                onClick={() => setOpen(false)}
                className="flex items-start gap-3 px-4 py-3 hover:bg-white/[0.05] transition-colors group"
              >
                <span className={`mt-0.5 w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${item.bg} ${item.color}`}>
                  <item.icon />
                </span>
                <div className="min-w-0">
                  <p className={`text-sm font-medium ${item.color} leading-snug`}>{item.label}</p>
                  <p className="text-text-muted text-xs mt-0.5 leading-snug">{item.description}</p>
                </div>
                <IconArrowRight className="text-text-muted mt-1.5 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

function Navbar() {
  const [dashboardHref, setDashboardHref] = useState<string | null>(null)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem('velink_token')
    if (!token) return
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      if (payload.exp * 1000 < Date.now()) {
        localStorage.removeItem('velink_token')
        return
      }
      if (payload.role === 'ADMIN') setDashboardHref('/admin')
      else if (payload.role === 'COMPANY') setDashboardHref('/dashboard')
      else if (payload.role === 'PROVIDER') setDashboardHref('/missions-disponibles')
    } catch {
      localStorage.removeItem('velink_token')
    }
  }, [])

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/[0.05] backdrop-blur-2xl border-b border-white/[0.08]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-[72px] flex items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 flex-1 flex-shrink-0">
          <div className="w-[30px] h-[30px] rounded-lg bg-accent/20 border border-accent/30 flex items-center justify-center">
            <span className="text-accent-hover font-bold text-sm">V</span>
          </div>
          <span className="font-semibold text-text-primary text-[17px] tracking-tight">Velink</span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          <Link to="/experts" className="text-text-secondary hover:text-text-primary text-sm transition-colors whitespace-nowrap">
            Trouver un expert
          </Link>
          <Link to="#comment-ca-marche" className="text-text-secondary hover:text-text-primary text-sm transition-colors whitespace-nowrap">
            Comment ça marche
          </Link>
          <Link to="#fonctionnalites" className="text-text-secondary hover:text-text-primary text-sm transition-colors whitespace-nowrap">
            Fonctionnalités
          </Link>
          <Link to="#tarifs" className="text-text-secondary hover:text-text-primary text-sm transition-colors whitespace-nowrap">
            Tarifs
          </Link>
        </nav>

        <div className="hidden md:flex items-center gap-5 flex-1 justify-end">
          {dashboardHref ? (
            <Link to={dashboardHref} className="text-sm font-semibold text-accent-hover hover:text-accent transition-colors whitespace-nowrap">
              Mon espace →
            </Link>
          ) : (
            <>
              <Link to="/connexion" className="text-text-secondary hover:text-text-primary text-sm transition-colors whitespace-nowrap">
                Connexion
              </Link>
              <VousEtesDropdown />
            </>
          )}
        </div>

        {/* Mobile burger */}
        <button
          className="md:hidden glass-btn px-3 py-2 text-sm ml-auto"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Menu"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            {mobileOpen
              ? <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          className="md:hidden border-t border-white/[0.08] px-4 py-4 space-y-1"
          style={{ background: 'rgba(10,10,20,0.97)', backdropFilter: 'blur(24px)' }}
        >
          <p className="text-text-muted text-[10px] font-semibold uppercase tracking-widest px-3 pb-2">Je suis…</p>
          {VOUS_ETES.map((item) => (
            <Link
              key={item.label}
              to={item.href}
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-white/[0.06] transition-colors"
            >
              <span className={item.color}><item.icon /></span>
              <span className={`text-sm font-medium ${item.color}`}>{item.label}</span>
            </Link>
          ))}
          <hr className="glass-divider my-2" />
          <Link to="/experts" onClick={() => setMobileOpen(false)} className="block px-3 py-2.5 text-text-secondary text-sm hover:text-text-primary transition-colors">Trouver un expert</Link>
          <Link to="#comment-ca-marche" onClick={() => setMobileOpen(false)} className="block px-3 py-2.5 text-text-secondary text-sm hover:text-text-primary transition-colors">Comment ça marche</Link>
          <Link to="#fonctionnalites" onClick={() => setMobileOpen(false)} className="block px-3 py-2.5 text-text-secondary text-sm hover:text-text-primary transition-colors">Fonctionnalités</Link>
          <Link to="#tarifs" onClick={() => setMobileOpen(false)} className="block px-3 py-2.5 text-text-secondary text-sm hover:text-text-primary transition-colors">Tarifs</Link>
          <hr className="glass-divider my-2" />
          {dashboardHref ? (
            <Link to={dashboardHref} className="block glass-btn-accent px-4 py-3 text-sm text-center rounded-xl">Mon espace →</Link>
          ) : (
            <div className="flex gap-3">
              <Link to="/connexion" className="flex-1 glass-btn px-4 py-3 text-sm text-center rounded-xl">Connexion</Link>
              <Link to="/inscription" className="flex-1 glass-btn-accent px-4 py-3 text-sm text-center rounded-xl">Commencer</Link>
            </div>
          )}
        </div>
      )}
    </header>
  )
}

// ─── Hero — un problème, la bonne personne, une solution ──────────────────────

function NetworkPanel() {
  const pulse = (r: number) => ({ ['--r' as unknown as string]: `${r}px` } as React.CSSProperties)

  return (
    <div className="relative w-full max-w-[460px] mx-auto lg:mx-0 aspect-[460/560] rounded-3xl glass-card overflow-hidden flex items-center justify-center">
      <svg viewBox="0 0 460 560" className="w-full h-full">
        <defs>
          <linearGradient id="flowV" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#8B9AFF" stopOpacity="0.9" />
            <stop offset="50%" stopColor="#8B9AFF" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#4ADE80" stopOpacity="0.9" />
          </linearGradient>
        </defs>

        <g fill="rgba(255,255,255,0.14)">
          <circle cx="90" cy="70" r="3" /><circle cx="130" cy="140" r="3" /><circle cx="70" cy="200" r="3" />
          <circle cx="360" cy="90" r="3" /><circle cx="390" cy="180" r="3" /><circle cx="340" cy="250" r="3" />
          <circle cx="100" cy="400" r="3" /><circle cx="150" cy="470" r="3" /><circle cx="370" cy="420" r="3" />
          <circle cx="330" cy="490" r="3" /><circle cx="230" cy="60" r="3" /><circle cx="230" cy="500" r="3" />
        </g>
        <g stroke="rgba(255,255,255,0.08)" strokeWidth={1}>
          <line x1="90" y1="70" x2="130" y2="140" /><line x1="130" y1="140" x2="70" y2="200" />
          <line x1="360" y1="90" x2="390" y2="180" /><line x1="390" y1="180" x2="340" y2="250" />
          <line x1="100" y1="400" x2="150" y2="470" /><line x1="370" y1="420" x2="330" y2="490" />
        </g>

        <path
          d="M 230 130 C 180 220, 280 300, 230 390"
          fill="none"
          stroke="url(#flowV)"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeDasharray="10 14"
          className="animate-dash-flow"
        />

        <circle cx="230" cy="130" r="9" fill="#8B9AFF" className="animate-node-pulse" style={pulse(9)} />
        <circle cx="230" cy="130" r="20" fill="none" stroke="rgba(139,154,255,0.35)" />
        <text x="230" y="98" textAnchor="middle" fontFamily="Inter, sans-serif" fontSize="13" fontWeight={600} fill="#C7CBFF">Un besoin</text>

        <circle cx="230" cy="280" r="10" fill="#4ADE80" className="animate-node-pulse" style={pulse(10)} />
        <circle cx="230" cy="280" r="22" fill="none" stroke="rgba(74,222,128,0.35)" />
        <text x="290" y="285" textAnchor="start" fontFamily="Inter, sans-serif" fontSize="13" fontWeight={600} fill="#B7F0CB">La bonne personne</text>

        <circle cx="230" cy="390" r="16" fill="rgba(74,222,128,0.16)" stroke="#4ADE80" strokeWidth={1.5} />
        <path d="M223 390 l5 5 l10 -11" fill="none" stroke="#4ADE80" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        <text x="230" y="432" textAnchor="middle" fontFamily="Inter, sans-serif" fontSize="13" fontWeight={600} fill="#B7F0CB">Une solution</text>
      </svg>
    </div>
  )
}

interface FeaturedDomain { id: string; slug: string; label: string; icon: string }

// Barre « De quel expert avez-vous besoin ? » + raccourcis vers les domaines ★ mis en avant (pilotés depuis l'admin)
function ExpertSearch() {
  const [domains, setDomains] = useState<FeaturedDomain[]>([])

  useEffect(() => {
    apiFetch<(FeaturedDomain & { featured: boolean })[]>('/public/domains')
      .then((all) => setDomains(all.filter((d) => d.featured).slice(0, 8)))
      .catch(() => {})
  }, [])

  function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    const fd = new FormData(e.currentTarget)
    const p = new URLSearchParams()
    const q = String(fd.get('q') ?? '').trim()
    const city = String(fd.get('city') ?? '').trim()
    if (q) p.set('q', q)
    if (city) p.set('city', city)
    window.location.assign(`/experts${p.toString() ? `?${p}` : ''}`)
  }

  return (
    <div className="mb-8">
      <form onSubmit={onSubmit} className="glass-card p-2 flex flex-col sm:flex-row gap-2">
        <div className="flex-1 flex items-center gap-2 px-3">
          <span className="text-text-muted">🔍</span>
          <input
            name="q"
            placeholder="De quel expert avez-vous besoin ? SSIAP, formateur SST…"
            className="w-full bg-transparent py-2.5 text-sm text-text-primary placeholder:text-text-muted outline-none"
            aria-label="Expert recherché"
          />
        </div>
        <div className="flex items-center gap-2 px-3 sm:border-l sm:border-white/[0.10]">
          <span className="text-text-muted">📍</span>
          <input
            name="city"
            placeholder="Ville"
            className="w-full sm:w-28 bg-transparent py-2.5 text-sm text-text-primary placeholder:text-text-muted outline-none"
            aria-label="Ville"
          />
        </div>
        <button type="submit" className="glass-btn-accent px-5 py-2.5 text-sm rounded-xl whitespace-nowrap">
          Trouver un expert
        </button>
      </form>

      {domains.length > 0 && (
        <div className="flex gap-2 flex-wrap justify-center lg:justify-start mt-3">
          {domains.map((d) => (
            <Link key={d.id} to={`/experts?domain=${encodeURIComponent(d.slug)}`} className="glass-btn px-3 py-1.5 text-xs rounded-full">
              {d.icon} {d.label}
            </Link>
          ))}
          <Link to="/experts" className="px-3 py-1.5 text-xs text-text-muted hover:text-text-primary transition-colors">
            Tous les domaines →
          </Link>
        </div>
      )}
    </div>
  )
}

function HeroSection() {
  return (
    <section className="pt-40 pb-24 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[1fr_460px] gap-14 lg:gap-16 items-center">

        <div className="max-w-xl mx-auto lg:mx-0 text-center lg:text-left">
          <p className="text-text-muted text-xs font-semibold uppercase tracking-[0.16em] mb-6">Une idée simple</p>

          <h1 className="text-5xl md:text-[52px] font-bold tracking-tight leading-[1.12] mb-6 text-text-primary">
            Un problème.<br />
            <span className="text-success">La bonne personne.</span><br />
            Une solution.
          </h1>

          <p className="text-lg text-text-secondary leading-relaxed mb-8">
            Velink connecte les organisateurs d'événements et centres de formation avec des agents ADS / SSIAP
            et formateurs qualifiés — la bonne personne, au bon moment, près de chez vous.
          </p>

          <ExpertSearch />

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-6">
            <Link to="/inscription/entreprise" className="glass-btn-accent px-8 py-4 text-base rounded-xl w-full sm:w-auto">
              Publier une mission
            </Link>
            <Link to="/inscription/prestataire" className="glass-btn px-8 py-4 text-base rounded-xl w-full sm:w-auto">
              Devenir prestataire
            </Link>
          </div>

          <p className="text-text-muted text-xs">
            Paiement sécurisé Stripe / PayPal · Agents CNAPS habilités · 1ère mission sans commission
          </p>
        </div>

        <NetworkPanel />
      </div>
    </section>
  )
}

// ─── Comment ça marche ────────────────────────────────────────────────────────

const steps = [
  {
    icon: IconFilePlus,
    step: '01',
    title: "Un besoin est publié",
    description:
      "L'entreprise décrit sa mission : type, lieu, date, durée et budget proposé — en moins de deux minutes.",
  },
  {
    icon: IconBell,
    step: '02',
    title: 'La bonne personne est alertée',
    description:
      'Les prestataires qualifiés et disponibles à proximité reçoivent une notification instantanée.',
  },
  {
    icon: IconCheckCircle,
    step: '03',
    title: 'La mission est résolue',
    description:
      'Le prestataire accepte, réalise la mission. Le paiement, sécurisé via Stripe ou PayPal, est alors libéré.',
  },
] as const

function HowItWorks() {
  return (
    <section id="comment-ca-marche" className="py-24 px-6">
      <div className="max-w-6xl mx-auto">

        <div className="text-center mb-16">
          <p className="text-accent-hover text-sm font-medium uppercase tracking-widest mb-3">Processus</p>
          <h2 className="text-4xl font-bold text-text-primary">Comment ça marche ?</h2>
          <p className="text-text-secondary mt-4 max-w-xl mx-auto">
            De la publication à la résolution, Velink relie les bonnes personnes en quelques minutes.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-0 md:divide-x divide-white/[0.10]">
          {steps.map((s, i) => (
            <div key={s.step} className={`px-0 md:px-10 ${i === 0 ? 'md:pl-0' : ''} ${i === steps.length - 1 ? 'md:pr-0' : ''} py-6 md:py-0`}>
              <span className="text-text-muted text-xs font-semibold tracking-widest">{s.step}</span>
              <div className="w-9 h-9 flex items-center justify-center text-text-secondary mt-5 mb-4">
                <s.icon />
              </div>
              <h3 className="text-lg font-semibold text-text-primary mb-2.5">{s.title}</h3>
              <p className="text-text-secondary text-sm leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

// ─── Fonctionnalités ──────────────────────────────────────────────────────────

const features = [
  {
    icon: IconMapPin,
    title: 'Matching géographique',
    description:
      "PostGIS calcule en temps réel les prestataires disponibles dans le rayon défini par l'entreprise.",
    tag: 'Temps réel',
    color: '#4ADE80',
  },
  {
    icon: IconBell,
    title: 'Notifications push',
    description:
      'Firebase Cloud Messaging envoie une alerte immédiate avec montant, date et localisation approximative.',
    tag: 'Firebase FCM',
    color: '#8B9AFF',
  },
  {
    icon: IconCreditCard,
    title: 'Paiement sécurisé',
    description:
      'Stripe Connect et PayPal avec capture différée. Le prestataire est payé uniquement après validation.',
    tag: 'Escrow',
    color: '#8B9AFF',
  },
  {
    icon: IconStar,
    title: 'Système de notation',
    description:
      'Les entreprises notent les prestataires après chaque mission, pour renforcer la confiance sur la plateforme.',
    tag: 'Confiance',
    color: '#FBBF24',
  },
  {
    icon: IconBarChart,
    title: 'Dashboard entreprise',
    description:
      "Suivi en temps réel des missions, historique, facturation et analytics depuis l'interface web.",
    tag: 'Analytics',
    color: '#A8A8B8',
  },
  {
    icon: IconSmartphone,
    title: 'App mobile prestataire',
    description:
      'Application React Native (iOS + Android) pour gérer ses missions, accepter des offres et suivre ses revenus.',
    tag: 'iOS & Android',
    color: '#A8A8B8',
  },
] as const

function FeaturesSection() {
  return (
    <section id="fonctionnalites" className="py-24 px-6">
      <div className="max-w-6xl mx-auto">

        <div className="text-center mb-16">
          <p className="text-accent-hover text-sm font-medium uppercase tracking-widest mb-3">Fonctionnalités</p>
          <h2 className="text-4xl font-bold text-text-primary">Tout ce dont vous avez besoin</h2>
          <p className="text-text-secondary mt-4 max-w-xl mx-auto">
            Une infrastructure robuste pour connecter les bons interlocuteurs sans friction.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => (
            <div key={f.title} className="bg-white/[0.04] border border-white/[0.10] rounded-2xl p-7 transition-colors hover:border-white/[0.18]">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center mb-5"
                style={{ backgroundColor: `${f.color}1f`, color: f.color }}
              >
                <f.icon />
              </div>
              <h3 className="text-base font-semibold text-text-primary mb-2">{f.title}</h3>
              <p className="text-text-secondary text-sm leading-relaxed mb-4">{f.description}</p>
              <span className="text-xs font-medium" style={{ color: f.color }}>{f.tag}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

// ─── Stats ────────────────────────────────────────────────────────────────────

const stats = [
  { value: '47', label: 'Prestataires inscrits en pré-lancement' },
  { value: '< 2 min', label: 'De la publication à la 1ère notification push' },
  { value: '0 %', label: 'Commission sur votre 1ère mission' },
  { value: '100 %', label: 'Paiement sécurisé et garanti' },
]

function StatsSection() {
  return (
    <section className="py-16 px-6">
      <div className="max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:divide-x divide-white/[0.10]">
        {stats.map((s) => (
          <div key={s.label} className="text-center sm:px-6 first:pl-0 last:pr-0">
            <p className="text-4xl font-bold mb-2 text-text-primary">{s.value}</p>
            <p className="text-text-secondary text-sm">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

// ─── Commission ───────────────────────────────────────────────────────────────

function CommissionSection() {
  return (
    <section id="tarifs" className="py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-accent-hover text-sm font-medium uppercase tracking-widest mb-3">Tarification</p>
          <h2 className="text-4xl font-bold text-text-primary">Transparent, sans surprise</h2>
          <p className="text-text-secondary mt-4 max-w-xl mx-auto">
            Inscription gratuite. Vous ne payez qu'à la réalisation d'une mission.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Entreprises */}
          <div className="bg-white/[0.04] border border-white/[0.10] rounded-2xl p-8 flex flex-col gap-5">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-lg bg-accent/10 text-accent-hover flex items-center justify-center"><IconBuilding /></span>
              <h3 className="text-lg font-semibold text-text-primary">Entreprises</h3>
            </div>
            <ul className="space-y-3 text-sm text-text-secondary">
              <li className="flex items-start gap-3">
                <span className="text-success mt-1 flex-shrink-0"><IconCheck /></span>
                <span>Inscription et publication de missions <strong className="text-text-primary">gratuits</strong></span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-success mt-1 flex-shrink-0"><IconCheck /></span>
                <span><strong className="text-text-primary">0 % de commission</strong> sur votre 1ère mission réalisée</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent-hover mt-0.5 flex-shrink-0"><IconArrowRight /></span>
                <span>À partir de la 2ème mission : <strong className="text-text-primary">10 % du montant</strong> prélevés automatiquement via Stripe ou PayPal</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-success mt-1 flex-shrink-0"><IconCheck /></span>
                <span>Paiement uniquement après la réalisation — aucun frais en cas d'annulation avant démarrage</span>
              </li>
            </ul>
          </div>

          {/* Prestataires */}
          <div className="bg-white/[0.04] border border-white/[0.10] rounded-2xl p-8 flex flex-col gap-5 relative overflow-hidden">
            <div className="absolute top-4 right-4 px-2.5 py-1 rounded-full bg-success/10 border border-success/25 text-success text-[11px] font-semibold">
              Offre de lancement
            </div>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-lg bg-warning/10 text-warning flex items-center justify-center"><IconUser /></span>
              <h3 className="text-lg font-semibold text-text-primary">Prestataires</h3>
            </div>
            <ul className="space-y-3 text-sm text-text-secondary">
              <li className="flex items-start gap-3">
                <span className="text-success mt-1 flex-shrink-0"><IconCheck /></span>
                <span>Inscription <strong className="text-text-primary">100 % gratuite</strong>, sans abonnement</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-success mt-1 flex-shrink-0"><IconCheck /></span>
                <span>Vous recevez le <strong className="text-text-primary">montant brut affiché</strong> — la commission est prélevée côté entreprise</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-success mt-1 flex-shrink-0"><IconCheck /></span>
                <span>Paiement sous <strong className="text-text-primary">48 h</strong> après validation de la mission</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-success mt-1 flex-shrink-0"><IconCheck /></span>
                <span>Pas de frais cachés, pas d'exclusivité — vous gérez votre agenda librement</span>
              </li>
            </ul>
          </div>
        </div>

        <p className="text-center text-text-muted text-xs mt-6">
          * Offre de lancement susceptible d'évoluer. Les prestataires et entreprises inscrits avant la sortie officielle
          bénéficient d'un maintien de leurs conditions pendant 12 mois.
        </p>
      </div>
    </section>
  )
}

// ─── Fondateurs ───────────────────────────────────────────────────────────────

function FoundersSection() {
  return (
    <section className="py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-accent-hover text-sm font-medium uppercase tracking-widest mb-3">L'équipe</p>
          <h2 className="text-4xl font-bold text-text-primary">Qui sommes-nous ?</h2>
          <p className="text-text-secondary mt-4 max-w-xl mx-auto">
            Velink est né d'un constat terrain : trouver la bonne personne pour un besoin précis prend trop de temps,
            trop d'appels, trop d'incertitude. Nous avons décidé d'y remédier.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="bg-white/[0.04] border border-white/[0.10] rounded-2xl p-8 max-w-sm w-full text-center">
            <div className="w-20 h-20 rounded-2xl bg-accent/20 border border-accent/30 flex items-center justify-center mx-auto mb-5">
              <span className="text-accent-hover font-bold text-2xl">JR</span>
            </div>
            <h3 className="text-text-primary font-semibold text-lg mb-1">Jeremy Roger</h3>
            <p className="text-accent-hover text-sm font-medium mb-4">Fondateur &amp; CEO</p>
            <p className="text-text-secondary text-sm leading-relaxed">
              Passionné par les problématiques opérationnelles de la sécurité événementielle et de la formation professionnelle.
              Velink est la plateforme qu'il aurait voulu avoir plus tôt.
            </p>
            <div className="flex items-center justify-center gap-3 mt-5">
              <a href="mailto:contact@velink.fr" className="px-4 py-2 glass-btn text-xs rounded-xl">
                contact@velink.fr
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

// ─── CTA Final ────────────────────────────────────────────────────────────────

function CTASection() {
  return (
    <section className="py-28 px-6">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-text-secondary text-base mb-10 max-w-lg mx-auto leading-relaxed">
          Que le besoin soit technique, créatif ou humain — quelqu'un, quelque part dans le réseau,
          <span className="text-text-primary font-medium"> sait y répondre.</span>
        </p>

        <div className="glass-card p-12">
          <p className="text-success text-sm font-medium uppercase tracking-widest mb-4">Lancement</p>
          <h2 className="text-4xl font-bold text-text-primary mb-4">
            Rejoignez Velink dès aujourd'hui
          </h2>
          <p className="text-text-secondary mb-10 max-w-lg mx-auto leading-relaxed">
            Que vous ayez un besoin à combler ou une expertise à proposer, Velink met en relation
            les bonnes personnes, au bon moment.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/inscription/entreprise" className="glass-btn-accent px-8 py-4 text-base rounded-xl w-full sm:w-auto">
              Je suis une entreprise →
            </Link>
            <Link to="/inscription/prestataire" className="glass-btn px-8 py-4 text-base rounded-xl w-full sm:w-auto">
              Je suis prestataire
            </Link>
          </div>
          <p className="text-text-muted text-xs mt-8">
            Aucune carte bancaire requise · Inscription gratuite · Paiement uniquement à la mission
          </p>
        </div>
      </div>
    </section>
  )
}

// ─── Footer ───────────────────────────────────────────────────────────────────

function Footer() {
  return (
    <footer className="border-t border-white/[0.08] py-10 px-6">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-accent/20 border border-accent/30 flex items-center justify-center">
            <span className="text-accent-hover font-bold text-xs">V</span>
          </div>
          <span className="text-text-secondary text-sm">Velink © 2026</span>
        </div>
        <div className="flex items-center gap-6 text-sm text-text-muted">
          <Link to="/mentions-legales" className="hover:text-text-secondary transition-colors">
            Mentions légales
          </Link>
          <Link to="/cgv" className="hover:text-text-secondary transition-colors">
            CGV
          </Link>
          <Link to="/confidentialite" className="hover:text-text-secondary transition-colors">
            Confidentialité
          </Link>
          <Link to="/contact" className="hover:text-text-secondary transition-colors">
            Contact
          </Link>
        </div>
        <span className="text-text-muted text-xs">v1.5.2</span>
      </div>
    </footer>
  )
}

// ─── Page ─────────────────────────────────────────────────────────────────────

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <hr className="glass-divider mx-6" />
        <HowItWorks />
        <hr className="glass-divider mx-6" />
        <FeaturesSection />
        <StatsSection />
        <hr className="glass-divider mx-6" />
        <CommissionSection />
        <hr className="glass-divider mx-6" />
        <FoundersSection />
        <hr className="glass-divider mx-6" />
        <CTASection />
      </main>
      <Footer />
    </>
  )
}
